import React from 'react'
import Layout from '../shared/Layout'

const ExpectedPayments = () => {
  return (
    <Layout title="List of expected payments" >Expected Payments not yet paid</Layout>
  )
}

export default ExpectedPayments